// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3rDjk","boxTitle":"Qualiphy_boxTitle__e_WY2","box":"Qualiphy_box__3mGvp","toggleWrap":"Qualiphy_toggleWrap__2Xo37"};